export default class RandomWithSeed {
	// Converted from RandomWithSeed.as
    /// From http://www.kirupa.com/forum/showthread.php?365564-AS3-Seeded-Pseudo-Random-Number-Generator
    /*
    Typical usage:
    let randWithSeed:RandomWithSeed;
    let _seed:number = 0;
    _seed = Number(10000*Math.random()) // for truly random.  Or set to 0 for repeatable results.
    randWithSeed = new RandomWithSeed(_seed); // Creates object
    eirp = randWithSeed.randRange(-3, 3);


		*/
		// Fields
		private _inext:number;
		private _inextp:number;
		private MBIG:number = 0x7fffffff;
		private MSEED:number = 0x9a4ec86;
		private MZ:number = 0;
		private _seed:number;
		private _seedArray:Array<number>;
		
		constructor(seedVal:number) {
			this._seed = seedVal;
			this._seedArray = new Array<number>(0x38);
			let num2:number = 0x9a4ec86 - Math.abs(this._seed);
			this._seedArray[0x37] = num2;
			let num3:number = 1;
			for (let i:number = 1; i < 0x37; i++)
			{
				let index:number = (0x15 * i) % 0x37;
				this._seedArray[index] = num3;
				num3 = num2 - num3;
				if (num3 < 0)
				{
					num3 += 0x7fffffff;
				}
				num2 = this._seedArray[index];
			}
			for (let j:number = 1; j < 5; j++)
			{
				for (let k:number = 1; k < 0x38; k++)
				{
					this._seedArray[k] -= this._seedArray[1 + ((k + 30) % 0x37)];
					if (this._seedArray[k] < 0)
					{
						this._seedArray[k] += 0x7fffffff;
					}
				}
			}
			this._inext = 0;
			this._inextp = 0x15;
			seedVal = 1; // Not sure why
		}
		public get seed():number
		{
			return this._seed;
		}
		
		private getSampleForLargeRange():number
		{
			let num:number = this.internalSample();
			if ((this.internalSample() % 2) == 0)
			{
				num = -num;
			}
			let num2:number = num;
			num2 += 2147483646.0;
			return (num2 / 4294967293);
		}
		
		private internalSample():number
		{
			let inext:number = this._inext;
			let inextp:number = this._inextp;
			if (++inext >= 0x38)
			{
				inext = 1;
			}
			if (++inextp >= 0x38)
			{
				inextp = 1;
			}
			let num:number = this._seedArray[inext] - this._seedArray[inextp];
			if (num < 0)
			{
				num += 0x7fffffff;
			}
			this._seedArray[inext] = num;
			this._inext = inext;
			this._inextp = inextp;
			return num;
		}
		
		public nextInt():number
		{	
			return this.internalSample();
		}
		
		public nextMax(maxValue:number):number
		{
			if (maxValue < 0)
			{
				console.log("ERROR in RandomWithSeed.nextMax Argument "+maxValue+" must be positive.");
			}
			return Number(this.sample() * maxValue);
		}
		
		public nextMinMax(minValue:number, maxValue:number):number
		{
			if (minValue > maxValue)
			{
				console.log("ERROR in RandomWithSeed.nextMax Argument "+minValue+" must be less than or equal to "+maxValue+".");
			}
			let num:number = maxValue - minValue;
			if (num <= 0x7fffffff)
			{
				return (((Number) (this.sample() * num)) + minValue);
			}
			return (((Number) (Number(this.getSampleForLargeRange() * num))) + minValue);
		}
		/*
		public nextBytes(buffer:ByteArray, length:number):void
		{
			if (buffer == null)
			{
				throw new ArgumentError("Argument \"buffer\" cannot be null.");
			}
			for (let i:number = 0; i < length; i++)
			{
				buffer.writeByte(this.internalSample() % 0x100);
			}
		}
		*/
		public nextNumber():number
		{
			return this.sample();
		}
		
		protected sample():number
		{
			return (this.internalSample() * 4.6566128752457969E-10);
		}
		public randRange(min, max){
			return min + (max-min)*this.sample();
		}
								
		
		
} // End class